// La duración de una música generada (ElevenLabs Music, `music_v2_5`). Los topes y el
// default son los mismos que `acotarDuracionDeMusica` del backend
// (atlas-backend/src/providers/elevenLabsAudio.ts): ElevenLabs acepta de 3 s a 10 min, el
// tope de 5 min es nuestro y sin duración sale un tema de 30 s
// (ADR-2026-09-26-musica-con-elevenlabs-y-duracion).

export const MUSICA_DURACION_MIN_SEG = 3;
export const MUSICA_DURACION_MAX_SEG = 300;
export const MUSICA_DURACION_DEFAULT_SEG = 30;

export function acotarDuracionDeMusica(seg: unknown): number {
  const n = typeof seg === 'number' ? seg : Number(seg);
  if (!Number.isFinite(n) || n <= 0) return MUSICA_DURACION_DEFAULT_SEG;
  return Math.min(MUSICA_DURACION_MAX_SEG, Math.max(MUSICA_DURACION_MIN_SEG, Math.round(n)));
}

/** "45 s" o "1:30 min", para el valor del control. */
export function formatearDuracionDeMusica(seg: number): string {
  const s = acotarDuracionDeMusica(seg);
  if (s < 60) return `${s} s`;
  return `${Math.floor(s / 60)}:${String(s % 60).padStart(2, '0')} min`;
}
